


// 保存浏览记录
export const saveHistoryApi = (params = {}) => {
  return httpRequest.post(`/media-site/h5/watchHistory/watchHistory/save`, params, { server: false })
}
// 取消浏览记录
export const cancelHistoryApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/watchHistory/watchHistory/deleteById', params, { server: false })
}

// 保存收藏
export const saveCollectApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/favorite/collection/save', params, { server: false })
}
// 取消收藏
export const cancelCollectApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/favorite/collection/delete/id', params, { server: false })
}
// 点赞
export const saveLikeApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/like/save',params,{server:false})
}
// 取消点赞
export const cancelLikeApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/like/delete',params,{server:false})
}
// 点赞列表
export const likeListApi = (params = {}) => {
  return httpRequest.post('/media-site/h5/like/list',params,{server:false})
}
